import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { TelegramService } from '../telegram/telegram.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnDestroy {
  userName = '';
  private sub: Subscription;

  constructor(
    public authService: AuthService,
    private telegramService: TelegramService,
  ) {
    this.sub = authService.currentUser$.subscribe(user => {
      if (user) {
        this.userName = user.first_name || user.username;
      }
    });
  }

  logout(): void {
    if (this.telegramService.isTelegram) {
      this.telegramService.close();
    } else {
      this.authService.logout();
      window.location.href = '/login';
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}